import { useCallback } from 'react';
import { parseParam, convertParam } from './converters';

export type GetUrlParamActionsParams = {
  name: string;
  search?: string;
  history?: { push: (path: string) => void };
};

export const useUrlActions = <T>({
  name,
  search,
  history,
}: GetUrlParamActionsParams) => {
  const getParamFromUrl = useCallback(() => {
    try {
      const param = new URLSearchParams(search).get(name);

      return parseParam<T>(param);
    } catch (ex) {
      return undefined;
    }
  }, [name, search]);

  const setParamToUrl = useCallback(
    (param?: T) => {
      const params = new URLSearchParams(search);
      const urlParam = convertParam(param);

      urlParam ? params.set(name, urlParam) : params.delete(name);

      history?.push(`?${params.toString()}`);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search, name]
  );

  return [getParamFromUrl, setParamToUrl] as const;
};
